import { useState } from 'react';
import { ShieldOff } from 'lucide-react';
import { useModal } from '../../hooks/modalContext';
import { removeMFA } from '../../../auth/_requests';
import { useAuth } from '../../../auth/Auth';
import toast from 'react-hot-toast';
import { useMFA } from '../../hooks/mfaListContext';
import { showToast } from '../../utils/showToast';

const RemoveMFA = () => {
  const { auth } = useAuth();
  const { setEmailEnabled, setPhoneEnabled } = useMFA();
  const { setModal, modalState } = useModal();

  const [loading, setLoading] = useState(false);

  const isEmail = modalState?.isEmailVerification;

  const handleRemove = async () => {
    try {
      setLoading(true);
      await removeMFA(auth?.data.token || '', modalState?.mfaId || '');
      toast.remove();

      showToast({
        message: isEmail
          ? 'Email MFA has been disabled successfully!'
          : 'Phone MFA has been disabled successfully!',
        type: 'success',
      });

      isEmail ? setEmailEnabled(false) : setPhoneEnabled(false);
      setModal('mfa-settings');
    } catch (error) {
      console.error('Error disabling MFA:', error);
      showToast({
        message: isEmail
          ? 'Failed to disable Email MFA. Please try again.'
          : 'Failed to disable Phone MFA. Please try again.',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='w-[380px] bg-white rounded-[16px] p-8 flex flex-col items-center gap-5'>
      <div className='w-14 h-14 rounded-full bg-red-50 flex items-center justify-center'>
        <ShieldOff size={26} className='text-red-500' />
      </div>

      <div className='flex flex-col items-center gap-2 text-center'>
        <h2 className='text-[20px] font-semibold text-[#0A0B14]'>
          {isEmail ? 'Disable email MFA' : 'Disable phone MFA'}
        </h2>
        <p className='text-[14px] text-[#6B7285] leading-relaxed'>
          Are you sure you want to disable Multi-Factor Authentication for your{' '}
          <span className='font-medium text-[#0A0B14]'>
            {isEmail ? 'email' : 'phone number'}
          </span>
          ? You can re-enable it at any time.
        </p>
      </div>

      <div className='flex gap-3 w-full mt-1'>
        <button
          className='cancelBtn'
          onClick={() => setModal('mfa-settings')}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          className='w-full h-[52px] flex items-center justify-center rounded-[10px] text-[14px] font-semibold text-white bg-red-500 hover:brightness-95 disabled:opacity-50 disabled:pointer-events-none'
          onClick={handleRemove}
          disabled={loading}
        >
          {loading ? 'Disabling...' : 'Disable'}
        </button>
      </div>
    </div>
  );
};

export default RemoveMFA;
